module.exports = __webpack_public_path__ + "static/media/lisa.fec33c80.png";